"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distinctRefiPositionSets = distinctRefiPositionSets;
exports.hasBaseOffer = hasBaseOffer;
exports.mandatoryLienPositions = mandatoryLienPositions;
exports.defaultSelectedLienPositions = defaultSelectedLienPositions;
exports.offersForPositions = offersForPositions;
exports.hasOffersForPositions = hasOffersForPositions;
const offerDetails_1 = require("./offerDetails");
function positionSetKey(positions) {
    return [...positions].sort((left, right) => left - right).join(',');
}
/** Distinct refinanced-lien position sets in offer order. An empty set is a non-refi offer. */
function distinctRefiPositionSets(offers) {
    const seen = new Set();
    const sets = [];
    for (const offer of offers) {
        const positions = (0, offerDetails_1.getOfferRefiPositions)(offer);
        const key = positionSetKey(positions);
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        sets.push(positions);
    }
    return sets;
}
/** Whether a non-refi (base) offer exists in the bag. */
function hasBaseOffer(offers) {
    return offers.some((offer) => (0, offerDetails_1.getOfferRefiPositions)(offer).length === 0);
}
/** Lien positions included in every offer. These positions cannot be deselected. */
function mandatoryLienPositions(offers) {
    if (offers.length === 0) {
        return [];
    }
    const [first, ...rest] = offers.map((offer) => (0, offerDetails_1.getOfferRefiPositions)(offer));
    return rest.reduce((common, positions) => {
        const positionSet = new Set(positions);
        return common.filter((position) => positionSet.has(position));
    }, first);
}
/** Defaults to mandatory positions, a base offer, or the smallest available refi set. */
function defaultSelectedLienPositions(offers) {
    const mandatory = mandatoryLienPositions(offers);
    if (mandatory.length > 0 && hasOffersForPositions(offers, mandatory)) {
        return mandatory;
    }
    if (hasBaseOffer(offers)) {
        return [];
    }
    const sets = distinctRefiPositionSets(offers).filter((positions) => positions.length > 0);
    if (sets.length === 0) {
        return [];
    }
    return sets.reduce((smallest, positions) => (positions.length < smallest.length ? positions : smallest), sets[0]);
}
/** Offers whose refi-position set exactly matches `selectedPositions`. */
function offersForPositions(offers, selectedPositions) {
    const selectedKey = positionSetKey(selectedPositions);
    return offers.filter((offer) => positionSetKey((0, offerDetails_1.getOfferRefiPositions)(offer)) === selectedKey);
}
function hasOffersForPositions(offers, selectedPositions) {
    const selectedKey = positionSetKey(selectedPositions);
    return offers.some((offer) => positionSetKey((0, offerDetails_1.getOfferRefiPositions)(offer)) === selectedKey);
}
